import Vue from 'vue';
import {
  loginByUserName,
  getInfo,
  getMenu,
  cancel,
  logout,
  resetToken,
  loginAuth
} from '@/api/login';
import {
  getToken,
  setToken,
  clearToken
} from '@/utils/auth';
import store from '@/store/index'
import {
  sha256
} from 'js-sha256'
import CryptoJS from 'crypto-js';
import '@/utils/sm3/core';
import '@/utils/sm3/cipher-core';
import '@/utils/sm3/jsbn'
import '@/utils/sm3/jsbn2'
import { SM3Digest } from '@/utils/sm3/sm3'

var isRefreshing = false; // 是否需要刷新token 
const user = {
  state: {
    token: null,
    userInfo: null,
    menuInfo: null,
    userState: false,
    menuState: false
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      Vue.set(state, 'token', token);
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_MENU_INFO: (state, menuInfo) => {
      state.menuInfo = menuInfo;
    },
    SET_USER_STATE: (state, status) => {
      state.userState = status;
    },
    SET_MENU_STATE: (state, status) => {
      state.menuState = status;
    },
    LOGOUT_USER: state => {
      state.user = null;
      state.menuInfo = null;
      state.token = null;
      clearToken();
    }
  },
  actions: {
    LoginByUsername({
      commit
    }, userInfo) {
      let pwd = userInfo.password;
      let pwdData = CryptoJS.enc.Utf8.parse(pwd);
      let sm3keycur = new SM3Digest();
      let c3 = new Array(32);
      pwdData = sm3keycur.GetWords(pwdData.toString());
      sm3keycur.BlockUpdate(pwdData, 0, pwdData.length);
      sm3keycur.DoFinal(c3, 0);
      const time = userInfo.time;
      const vcode = userInfo.vcode;
      const userName = userInfo.username.trim();
      let password;
      if(store.getters.objApi.passwordEncryption === 'SM3') {
        password = sm3keycur.GetHex(c3).toString()
      } else {
        password = sha256(userInfo.password.trim())
      }
      const word = `${userInfo.time}|${password}`;
      const name = setCryptoJs(userName);
      const pass = setCryptoJs(word);
      return new Promise((resolve, reject) => {
        loginByUserName(name, pass, time, vcode).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        })
      })
    },    

    LoginByUser({
      commit
    }, userInfo) {
      const userName = userInfo.username.trim();
      const keyHex = CryptoJS.enc.Utf8.parse('lianyitech');
      const encrypted = CryptoJS.DES.encrypt(userName, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      const params = {};
      params.username = encrypted.toString();
      params.password = userInfo.password;
      params.code = userInfo.vcode;
      return new Promise((resolve, reject) => {
        loginAuth(params).then(response => {
          setToken(response);
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      })
    }, 

    /**
     * 1. 获取token
     * 2. 判断token是否超期 isPastDue
     * 3. token超期后，置空token，通过ResetToken重新获取token
     * 4. 重新赋值token
     */
    async GetToken({
      dispatch,
      commit,
      state
    }) {
      const token = getToken();
      if (token && token.access_token) {
        let hasNo = await dispatch('isPastDue', token.logTime);
        if (hasNo && !isRefreshing) {
          // commit('SET_TOKEN', null);
          isRefreshing = true;
          let newToken = await dispatch('ResetToken', token.refresh_token);
          isRefreshing = false;
          if (newToken) {
            if (newToken.access_token) {
              setToken(newToken);
              let _token = getToken();
              commit('SET_TOKEN', Object.assign(_token, { isPastDue: hasNo }));
              return Object.assign(_token, { isPastDue: hasNo });
            } else {
              return null;
            }
          } else {
            commit('LOGOUT_USER');
          }
        } else {
          commit('SET_TOKEN', Object.assign(token, { isPastDue: hasNo }));
          return Object.assign(token, { isPastDue: hasNo });
        }
      } else {
        return token;
      }
    },

    async isPastDue({
      commit,
      state
    }, logTime) { // 判断token是否过期的方法
      return logTime <= Date.parse(new Date());
    },

    async ResetToken({
      commit
    }, refreshToken) {
      try {
        const token = await resetToken(refreshToken);
        return token;
      } catch (error) {
        commit('LOGOUT_USER');
      }
    },

    ClearToken({
      commit
    }) {
      return new Promise((resolve, reject) => {
        clearToken().then(() => {
          commit('SET_TOKEN', null);
          commit('LOGOUT_USER');
          resolve();
        })
      })
    },

    GetInfo({
      commit,
      state
    }) {
      return state.userInfo && !state.userState ?
        Promise.resolve(state.userInfo) :
        new Promise((resolve, reject) => {
          getInfo().then(response => {
            const data = response.data;
            commit('SET_USER_INFO', data);
            resolve(data);
          }).catch(error => {
            reject(error);
          })
        })
    },

    GetMenu({
      commit,
      state
    }) {
      return state.menuInfo && !state.menuState ?
        Promise.resolve(state.menuInfo) :
        new Promise((resolve, reject) => {
          getMenu().then(response => {
            const data = response.data;
            commit('SET_MENU_INFO', data);
            resolve(data);
          }).catch(error => {
            reject(error);
          })
        })
    },

    Cancel({
      dispatch,
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        cancel().then(response => {
          dispatch('GetTreeData');
          commit('SET_MENU_STATE', true);
          commit('SET_USER_STATE', true);
          Promise.all([dispatch('GetMenu'), dispatch('GetInfo'), dispatch('GetPowerBtn')]).then(() => {
            resolve();
          });
        });
      }).catch(error => {
        reject(error);
      })
    },

    Logout({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout(this.getters.objApi.NODE_ID).then(response => {
          resolve();
        }).catch(error => {
          reject(error);
        })
      })
    }
  }
}

const setCryptoJs = (value) => {
  const keyHex = CryptoJS.enc.Utf8.parse('lianyitech');
  let _val = CryptoJS.DES.encrypt(value, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  let val = encodeURIComponent(_val.toString());
  return val;
}

export default user

// 国密加密方式
// const doSM3 = () => {
//   console.log('用户信息~~~');
//   console.log(user)
//   let pwd = user.userInfo.password;
//   let pwdData = CryptoJS.enc.Utf8.parse(pwd);
//   let sm3keycur = new SM3Digest();
//   pwdData = sm3keycur.GetWords(pwdData.toString());
//   sm3keycur.BlockUpdate(pwdData, 0, pwdData.length);
//   let c3 = new Array(32);
//   sm3keycur.DoFinal(c3, 0);
//   pwd = sm3keycur.GetHex(c3).toString();
// }



// WEBPACK FOOTER //
// ./src/store/modules/user.js